import React from "react";
import { Stack } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import "./context_components.css";
import { miActions } from "../../store/store";

export const Projects = () => {
  const { dateTime } = useSelector(state => state.miStore);
  const {
    color
  } = useSelector(state => state.miStore);
  const { page } = useSelector(state => state.miStore);
  const dispatch = useDispatch();

  const handleChangePage = () => {
    dispatch(miActions.changePage("preferences"));
    dispatch(miActions.setPrevPage(page));
  }

  return (
    <Stack
      direction="row"
      className="project-info-dark"
      sx={{
        justifyContent: "center",
        color: color
      }}
      onClick={handleChangePage}
    >
      <span>{dateTime}</span>
    </Stack >
  )
}